import React from 'react';
import { Helmet } from 'react-helmet';


function PrivacyPolicy() {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
<Helmet>
  <title>Meshum | Compare Car Prices with Sold Listings</title>
  <meta name="description" content="See what similar cars have sold for nearby. Use Meshum to get price insights before buying your next car." />
</Helmet>
      <h1>Privacy Policy</h1>
      <p>Last updated: May 2025</p>

      <p>
        Meshum ("we", "our", or "us") values your privacy. This Privacy Policy describes how we collect, use, and protect your personal information when you use our website (meshum.com).
      </p>

      <h2>Information We Collect</h2>
      <ul>
        <li><strong>Contact Information:</strong> When you sign up for our newsletter or submit inquiries.</li>
        <li><strong>Browsing Activity:</strong> We collect usage data like pages visited, IP address, and browser type.</li>
        <li><strong>Search and View History:</strong> We store recently viewed cars locally to improve your experience.</li>
      </ul>

      <h2>How We Use Information</h2>
      <ul>
        <li>To provide and improve our services</li>
        <li>To respond to inquiries</li>
        <li>To personalize content based on your activity</li>
        <li>To send updates or promotional materials (only if you opt in)</li>
      </ul>

      <h2>Cookies</h2>
      <p>
        We use cookies to track usage and store preferences. You can disable cookies in your browser settings.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        We use third-party tools like Google Analytics to help us understand website usage. These tools may collect anonymized information.
      </p>

      <h2>Your Rights</h2>
      <p>
        You may request to access, update, or delete your personal data at any time by contacting us at privacy@meshum.com.
      </p>

      <h2>Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted here.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have questions about this policy, email us at: privacy@meshum.com
      </p>
    </div>
  );
}

export default PrivacyPolicy;
